import { IdentityToken } from 'utils/class-identity-token';

let identityToken: IdentityToken | null = null;

export const getIdentityToken = (): IdentityToken => {
  if (!identityToken) {
    identityToken = new IdentityToken(import.meta.env.VITE_PARTNER_ID);
  }
  return identityToken;
};
